export default "__VITE_ASSET__51cecf39__"